// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessEmail_root__2Xi0A","text":"SuccessEmail_text__dlryc","icon":"SuccessEmail_icon__CxCLX"};